module.exports = __webpack_public_path__ + "static/media/FarmWise_logo.e92b136e.png";